import {Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";
import {Observable, Subject, take} from "rxjs";
import {
  addFavorite,
  clearFavorites,
  removeFavorite,
  setFavoritesCode,
  toggleFavorite
} from "../store/actions/user.actions";
import {getAllFavorites, getFavoritesByTypes, getFavoritesCode} from "../store/selectors/user.selector";
import {HttpClient} from "@angular/common/http";
import {OverlayService} from "../overlay/overlay.service";
import {SaveCompleteComponent} from "./save-complete/save-complete.component";
import {LoadFavoritesComponent} from "./load-favorites/load-favorites.component";
import {FavoriteEntityType} from "../enums/favorite-entity-type";
import {FavoriteEntity} from "../interfaces/favorite-entity";
import {DataService} from "../services/data.service";

@Injectable({
  providedIn: 'root'
})
export class FavoritesService {

  private _requestRemoveItem = new Subject<FavoriteEntity>();
  constructor(
    private store: Store,
    private router: Router,
    private http: HttpClient,
    private overlay: OverlayService,
    private data: DataService
  ) { }

  getRequestRemoveItem(): Observable<FavoriteEntity> {
    return this._requestRemoveItem;
  }

  requestRemoveItem(item: FavoriteEntity): void {
    this._requestRemoveItem.next(item);
  }

  getAllByType(...type: FavoriteEntityType[]): Observable<FavoriteEntity[]> {
    return this.store.select(getFavoritesByTypes(...type));
  }

  toggle(entity: FavoriteEntity): boolean {
    this.store.dispatch(toggleFavorite({entityType: entity.type, id: entity.id}));
    return true;
  }

  remove(entity: FavoriteEntity): boolean {
    this.store.dispatch(removeFavorite({id: entity.id}))
    return true;
  }

  goToSavedProfessions(): void {
    this.router.navigateByUrl("/merkliste/berufe");
  }

  async save(): Promise<void> {

    // Get local favorites
    const allFavorites = await new Promise<FavoriteEntity[]>((resolve, reject) => {
      this.store.select(getAllFavorites()).pipe(take(1)).subscribe((allFavorites) => {
        resolve(allFavorites);
      });
    });

    if(allFavorites.length) {

      // Get user current code
      let userOwnCode = await new Promise<string>((resolve) => {
        this.getUserFavoritesCode().then((code) => {
          resolve(code)
        })
      })

      console.warn("User owner code is ", userOwnCode);

      if(userOwnCode.length === 0) { // if it doesn't exist, create new with api
        userOwnCode = await new Promise<string>((resolve, reject) => {
          // console.log("Creating favorites");
          this.data.createFavorites().pipe(take(1)).subscribe((val) => {
            resolve(val);
          })
        })
      }

      console.warn("User owner code is ", userOwnCode);

      if(userOwnCode.length) {
        // then update favorites on server with code
        await new Promise<void>((resolve, reject) => {
          // console.log("Updating favorites");

          this.data.updateFavorites(userOwnCode, JSON.stringify(allFavorites)).pipe(take(1)).subscribe(() => {
            resolve();
          })
        });

        // update local store with code
        this.store.dispatch(setFavoritesCode({code: userOwnCode}));

        // show user his code
        this.overlay.openWindowOverlay({
          componentMain: {
            component: SaveCompleteComponent,
            data: {
              code: userOwnCode
            }
          },
          headerBottomLine: false,
          headerNoBackdropFilter: true
        })
      } else {
        console.error("Code was not created!");
      }
    }

    return;
  }

  getUserFavoritesCode(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.store.select(getFavoritesCode()).pipe(take(1)).subscribe((val) => {
        resolve(val);
      })
    })
  }


  load(code: string): Promise<boolean> { // RESOLVE TRUE IF FOUND, FALSE IF NOT FOUND WX6W17Y
    return new Promise<boolean>((resolve, reject) => {
      if(code.length) {
        this.data.getFavorites(code).pipe(take(1)).subscribe((favoritesString) => {
          if(favoritesString && favoritesString.length > 0) {

            this.store.dispatch(clearFavorites());

            const favoritesArray: FavoriteEntity[] = JSON.parse(favoritesString);
            if(favoritesArray && favoritesArray.length) {
              favoritesArray.forEach(el => {
                this.store.dispatch(addFavorite({id: el.id, entityType: el.type}));
              });
            }

            this.store.dispatch(setFavoritesCode({code: code}));
            resolve(true);
          } else {
            resolve(false);
          }
        });
      } else {
        resolve(false);
      }
    })
  }

  removeFavorites(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.store.select(getFavoritesCode()).pipe(take(1)).subscribe((code) => {

        // Clear all locally
        this.store.dispatch(clearFavorites());
        this.store.dispatch(setFavoritesCode({code: ""}));

        // If this were saved on server then clear also there
        if(code.length) {
          this.data.deleteFavorites(code).pipe(take(1)).subscribe((val) => {
            resolve();
          })
        } else {
          resolve();
        }
      })

    });
  }

  openCodeWindow() {
    this.overlay.openWindowOverlay({componentMain: {component: LoadFavoritesComponent, data: {}}});
  }
}
